<template>
  <div class="app-container asset-scrap-approval-page">
    <div class="page-heading">
      <div>
        <h3>资产报废审批</h3>
        <p>报修记录 #{{ repairRecordId }}；仅报废进入审批，审批通过后仍需资产管理员登记处置结果。</p>
      </div>
      <el-button icon="el-icon-back" @click="goBack">返回</el-button>
    </div>

    <el-alert
      type="info"
      show-icon
      :closable="false"
      title="简化审批：部门负责人 → 财务总监 → 总经理。审批通过不等于资产已报废，处置登记完成后才正式结束。"
    />

    <el-card v-if="workOrderId" class="approval-card" shadow="never">
      <div slot="header" class="approval-card__header">
        <span>审批单 SP{{ workOrderId }}</span>
        <el-tag v-if="approvalStatusText" size="mini" :type="approvalStatusTag">{{ approvalStatusText }}</el-tag>
      </div>
      <approve-info
        ref="approveInfo"
        :target-id="workOrderId"
        target-type="assetRepair"
        :allow-transfer="false"
        @update="handleApprovalUpdate"
        @success="handleApprovalSuccess"
      />
    </el-card>

    <el-alert
      v-else
      type="error"
      show-icon
      :closable="false"
      title="缺少审批单号，请从首页“我的待办”重新进入。"
    />
  </div>
</template>

<script>
import ApproveInfo from '@/views/crm/components/approveInfo'

export default {
  name: 'AssetRepairApproval',
  components: { ApproveInfo },
  data() {
    return {
      approvalStatus: null,
      approvalStatusText: ''
    }
  },
  computed: {
    repairRecordId() {
      return this.$route.params.id
    },
    workOrderId() {
      const value = Number(this.$route.query.workOrderId)
      return Number.isInteger(value) && value > 0 ? value : null
    },
    approvalStatusTag() {
      return ({ 0: 'info', 1: 'warning', 2: 'success', 3: 'danger', 4: 'info' })[Number(this.approvalStatus)] || 'info'
    }
  },
  methods: {
    handleApprovalUpdate(info) {
      this.approvalStatus = info && info.status
      this.approvalStatusText = (info && info.statusStr) || ''
    },
    handleApprovalSuccess() {
      this.$message.success('审批已提交，流程已流转到下一节点')
    },
    goBack() {
      if (window.history.length > 1) this.$router.back()
      else this.$router.push('/index')
    }
  }
}
</script>

<style scoped>
.asset-scrap-approval-page { max-width: 980px; margin: 0 auto; }
.page-heading { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 16px; }
.page-heading h3 { margin: 0 0 8px; font-size: 20px; }
.page-heading p { margin: 0; color: #606266; line-height: 1.6; }
.approval-card { margin-top: 16px; }
.approval-card__header { display: flex; align-items: center; justify-content: space-between; font-weight: 600; }
</style>
